var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":_vm.img}}),_c('p',[_vm._v("未到找指定页面")]),_c('Button',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回页面")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }